/* global axios */
import ApiClient from './ApiClient';

// NOTICE: KAPTION-INTEGRATION
// two-step-verification.API.2 — the profile "two-step verification" section.
// See Api::V1::Profile::KaptionTwoStepController. WhatsApp enrollment keeps its
// own endpoints (kaptionWhatsapp2fa.js).
class KaptionTwoStepAPI extends ApiClient {
  constructor() {
    super('profile/kaption_two_step', { accountScoped: false });
  }

  getStatus() {
    return axios.get(this.url);
  }

  // two-step-verification.API.3 — passes without a password right after
  // sign-in; otherwise send the password once (it then counts for 10 minutes).
  stepUp(password) {
    return axios.post(`${this.url}/step_up`, password ? { password } : {});
  }

  setPreferred(method) {
    return axios.patch(this.url, { preferred_method: method });
  }

  // The first set needs no password; replacing a set does.
  generateBackupCodes(password) {
    return axios.post(`${this.url}/backup_codes`, password ? { password } : {});
  }

  passkeyOptions() {
    return axios.post(`${this.url}/passkey_options`);
  }

  createPasskey(credential, nickname) {
    return axios.post(`${this.url}/passkeys`, { credential, nickname });
  }

  removePasskey(id, password) {
    return axios.delete(`${this.url}/passkeys/${id}`, { data: { password } });
  }

  startAuthenticator() {
    return axios.post(`${this.url}/authenticator`);
  }

  verifyAuthenticator(otpCode) {
    return axios.post(`${this.url}/authenticator/verify`, {
      otp_code: otpCode,
    });
  }

  removeAuthenticator(password) {
    return axios.delete(`${this.url}/authenticator`, { data: { password } });
  }

  // two-step-verification.RECOVERY.2 — an admin resets a member's methods.
  resetForUser(accountId, userId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/kaption_two_step_resets`,
      { user_id: userId }
    );
  }
}

export default new KaptionTwoStepAPI();
